import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { SelectModule } from 'primeng/select';

@Component({
  selector: 'app-property-options',
  templateUrl: './property-options.component.html',
  styleUrls: ['./property-options.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,

  imports: [SelectModule, FormsModule, ReactiveFormsModule],
})
export class PropertyOptionsComponent {
  @Input() label!: string;
  @Input() required = false;
  @Input() control!: UntypedFormControl;
  @Input() options!: any[];
  @Output() selectOption = new EventEmitter();
}
